import { render, staticRenderFns } from "./galleryView.vue?vue&type=template&id=1814e4f0&"
import script from "./galleryView.vue?vue&type=script&lang=js&"
export * from "./galleryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports